<template>
	<div class="link-document-item-demo-code">
		<link-scroll scrollX :scrollbarSize="6" scrollbarColor="rgba(255,255,255,0.5)">
			<link-document-markdown :value="html" v-if="html"/>
			<link-document-markdown :value="js" v-if="js"/>
			<link-document-markdown :value="css" v-if="css"/>
		</link-scroll>
		<div class="link-document-item-demo-code-copy" @click="pl_copy" v-link-tooltip="'复制代码'">
			<link-icon icon="icon-wenjuan1"/>
		</div>
	</div>
</template>

<script>
    export default {
        name: "link-document-item-demo-code",
        props: {
            data: {},
        },
        data() {
            return {
                html: null, css: null, js: null
            }
        },
        watch: {
            data: {
                immediate: true,
                handler(val) {
                    this.pl_reset()
                },
            },
        },
        methods: {
            pl_reset() {
                let {html, css, js} = this.data
                !!html && (html = '```html\n' + html + '\n```')
                !!css && (css = '```css\n' + css + '\n```')
                !!js && (js = '```js\n' + js + '\n```')

                Object.assign(this, {html, css, js})
            },
            pl_copy() {
                let {html, css, js} = this.data
                html = this.pl_wrapper('template', html)
                css = this.pl_wrapper('style', css)
                js = this.pl_wrapper('script', js)
                const message = `${html}\n${js}\n${css}`
                this.$lv.$utils.copyToClipboard(message, () => this.$msg.show('已经复制到剪切板！'), () => this.$msg.show('复制失败！', {type: 'error'}))
            },

            pl_wrapper(tag, val) {
                return `<${tag}>\n` + val + `\n</${tag}>`
            },
        }
    }
</script>

<style lang="scss">
	.link-document-item-demo-code {
		display: block;
		height: 100%;
		width: 100%;
		border-radius: 4px;
		box-sizing: border-box;
		position: relative;
		padding: 0 12px;
		background-color: #072513;

		.link-document-markdown {
			background-color: transparent;
		}

		.link-document-item-demo-code-copy {
			position: absolute;
			right: 1em;
			top: 1em;
			height: 28px;
			width: 28px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: white;
			border-radius: 36px;
			cursor: pointer;
			@include transition-all;

			&:hover {
				transform: scale(1.1);
			}

			&:active {
				transform: scale(1);
			}
		}

		pre {
			border-radius: 0 !important;
			background-color: transparent;
		}
	}
</style>
